// featureFlags.enum.ts

enum FeatureFlags {
    FISERV_GUEST_FLOW = "REACT_APP_FISERV_GUEST_FLOW_ENABLED",
    FISERV_LOYALTY_FLOW = "REACT_APP_FISERV_LOYALTY_FLOW_ENABLED",
    UPSELL = "REACT_APP_UPSELL_ENABLED",
    CART_ITEMS_CONFIRM = "REACT_APP_CART_ITEMS_CONFIRM_ENABLE",
    GIFT_CARD_TRANSFER = "GIFT_CARD_TRANSFER_ENABLED",
    PAY_WITH_GIFT_CARD = "PAY_WITH_GIFT_CARD_ENABLED",
    ADD_FUNDS_SECURITY_BANNER = "ADD_FUNDS_SECURITY_BANNER_ENABLED",
    ADD_FUNDS_SECURITY_BANNER_MSG = "ADD_FUNDS_SECURITY_BANNER_MSG",
    GUEST_COUPON = "GUEST_COUPON_ENABLED",
    LOYALTY_COUPON = "LOYALTY_COUPON_ENABLED",
    AUTO_RELOAD = "AUTO_RELOAD_ENABLED",
    ONE_TRUST_COOKIE = "ONE_TRUST_COOKIE_ENABLED",
    ORDERS_LOCATION_HEADER_LABEL = "ORDERS_LOCATION_HEADER_LABEL",
    ORDERS_LOCATION_NO_RESULTS_LABEL = "ORDERS_LOCATION_NO_RESULTS_LABEL",
    REWARDS_TERMS_AND_CONDITIONS = "ENABLE_REWARDS_TERMS_AND_CONDITIONS",
    GC_CONFIRMATION_EMAIL = "ENABLE_GC_CONFIRMATION_EMAIL",
    EBB_SMS_NOTIFICATION = "EBB_SMS_NOTIFICATION_ENABLED",
    TOAST = "IS_TOAST_ENABLED",
  }

export default FeatureFlags;
